export const kpiData = [
  {
    id: 'total-leads',
    label: 'Total Leads',
    value: 0,
    sub: 'No leads yet',
    trend: 0,
    positive: true,
    icon: 'ri-user-add-line',
    color: 'teal',
  },
  {
    id: 'active-bookings',
    label: 'Active Bookings',
    value: 0,
    sub: 'No bookings yet',
    trend: 0,
    positive: true,
    icon: 'ri-calendar-check-line',
    color: 'emerald',
  },
  {
    id: 'revenue',
    label: 'Revenue (MTD)',
    value: 0,
    sub: 'Month to date',
    trend: 0,
    positive: true,
    icon: 'ri-money-dollar-circle-line',
    color: 'green',
  },
  {
    id: 'pending-payments',
    label: 'Pending Payments',
    value: 0,
    sub: 'No pending payments',
    trend: 0,
    positive: true,
    icon: 'ri-time-line',
    color: 'amber',
  },
];

export const pipelineData: {
  status: string;
  color: string;
  bgColor: string;
  leads: { id: string; name: string; service: string; budget: string; days: string; source: string }[];
}[] = [];

export const recentBookings: {
  id: string;
  customer: string;
  avatar: string;
  service: string;
  serviceIcon: string;
  travelDate: string;
  status: string;
  amount: string;
  payStatus: string;
}[] = [];

export const tasksData: {
  id: string;
  title: string;
  priority: string;
  time: string;
  done: boolean;
  lead: string;
}[] = [];

export const aiMessages = [
  { id: 1, role: 'assistant', text: 'Hi! I\'m your AI travel assistant. I can help you draft quotes, summarize bookings, follow up with leads, and more. What do you need?' },
];

export const agencyInfo = {
  name: 'Horizon Travel',
  logo: 'HT',
  brandColor: '#0D9488',
  plan: 'Pro',
  currency: 'AED',
};
